import i18n from "@/i18n";
import store from "@/state/store";

export const languages = [
  {
    flag: require("@/assets/images/flags/us.svg"),
    language: "en",
    title: "English",
  },
  {
    flag: require("@/assets/images/flags/tr.svg"),
    language: "tr",
    title: "Türkçe",
  },
];

export function setLanguage(locale, country, flag) {
  const imgEl = document.getElementById("header-lang-img");
  if (imgEl) imgEl.setAttribute("src", flag);
  i18n.global.locale = locale;
  store.dispatch("app/setLanguageAction", { lang: locale });
  localStorage.setItem("language", locale);
}

export function initLanguageFlag() {
  const dil = localStorage.getItem("language") || "tr";
  const match = languages.find((l) => l.language === dil);
  if (match) {
    const imgEl = document.getElementById("header-lang-img");
    if (imgEl) imgEl.setAttribute("src", match.flag);
  }
}
